export interface ComposioConnectOptions {
  accountLabel?: string | null
  replacesConnectedAccountId?: string | null
}

export function submitComposioConnect(appSlug: string, workerId: string, options: ComposioConnectOptions = {}) {
  const popupName = `composio-connect-${appSlug}-${workerId}`.replace(/[^a-zA-Z0-9_-]/g, '-')
  const popup = window.open('about:blank', popupName, 'popup,width=720,height=820,resizable=yes,scrollbars=yes')
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = '/dashboard/composio/connect'
  form.target = popup ? popupName : '_blank'

  const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content
  if (csrfToken) {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = 'authenticity_token'
    input.value = csrfToken
    form.appendChild(input)
  }

  const slugInput = document.createElement('input')
  slugInput.type = 'hidden'
  slugInput.name = 'app_slug'
  slugInput.value = appSlug
  form.appendChild(slugInput)

  const workerInput = document.createElement('input')
  workerInput.type = 'hidden'
  workerInput.name = 'digital_worker_id'
  workerInput.value = workerId
  form.appendChild(workerInput)

  if (options.accountLabel) {
    const labelInput = document.createElement('input')
    labelInput.type = 'hidden'
    labelInput.name = 'account_label'
    labelInput.value = options.accountLabel
    form.appendChild(labelInput)
  }

  if (options.replacesConnectedAccountId) {
    const replacementInput = document.createElement('input')
    replacementInput.type = 'hidden'
    replacementInput.name = 'replaces_connected_account_id'
    replacementInput.value = options.replacesConnectedAccountId
    form.appendChild(replacementInput)
  }

  const popupInput = document.createElement('input')
  popupInput.type = 'hidden'
  popupInput.name = 'popup'
  popupInput.value = '1'
  form.appendChild(popupInput)

  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
  popup?.focus()
}
